const REGULAR_MODULE_TYPE = 'topItem';
const BANNER_MODULE_TYPE = 'topItemBanner';

export { REGULAR_MODULE_TYPE, BANNER_MODULE_TYPE };
